import {
  CapabilitiesTile,
  CalloutCard,
  ContentGalleryCard,
  ComponentSelector,
  EventCountdownTimer,
  HeroFlattenImage,
  HomeDecorCard,
  Image,
  PiccolaPencil,
  QuickLinks,
  MedioInline,
  LoyaltyBenefits,
  Sweepstakes,
  NewspaperModule,
  OnlineWorkshops,
  PersonalizedHomeServices,
  PopularCategories,
  PrivateLabelCreditCard,
  ProductShelf,
  Projects,
  PromotionCard,
  PromoVisualNavigation,
  Quotes,
  RecentOrders,
  RecentPurchases,
  Recommendations,
  Resource,
  SectionSelector,
  ShopByCategory,
  SignIn,
  SpecialBuyOfTheDay,
  SpecialBuyOfTheWeek,
  SponsoredBanner,
  Spotlight,
  SpotlightContainer,
  UserList,
  VisualNavigation,
  WelcomeMessage,
  BentoHero
} from '.';

export const components = {
  CapabilitiesTile,
  CalloutCard,
  ComponentSelector,
  EventCountdownTimer,
  HeroFlattenImage,
  HomeDecorCard,
  Image,
  PiccolaPencil,
  AnchorLinks: QuickLinks,
  MedioInline,
  LoyaltyBenefits,
  Sweepstakes,
  Newspaper: NewspaperModule,
  OnlineWorkshops,
  PersonalizedHomeServices,
  PopularCategories,
  PrivateLabelCreditCard,
  ProductShelf,
  Projects,
  PromotionCard,
  PromoVisualNavigation,
  RecentOrders,
  RecentPurchases,
  Recommendations,
  Resource,
  Section: SectionSelector,
  ShopByCategory,
  SignIn,
  SpecialBuyOfTheDay,
  SpecialBuyOfTheWeek,
  SponsoredBanner,
  Spotlight,
  SpotlightContainer,
  UserList,
  VisualNavigation,
  welcomeMessage: WelcomeMessage,
  BentoHero,
  Quotes,
  Gallery: ContentGalleryCard,
};
